import { Checkbox, Label } from "@cliently/ui";
import { LEGAL_PRIVACY_URL, LEGAL_TERMS_URL } from "../legal-urls";

type TermsAcceptanceCheckboxProps = {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
};

export const TermsAcceptanceCheckbox = ({
  id,
  checked,
  onCheckedChange,
  disabled,
}: TermsAcceptanceCheckboxProps) => (
  <div className="flex items-start gap-2">
    <Checkbox
      id={id}
      checked={checked}
      onCheckedChange={(value) => onCheckedChange(value === true)}
      disabled={disabled}
      className="mt-0.5"
      aria-required
    />
    <Label
      htmlFor={id}
      className="text-muted-foreground cursor-pointer text-xs leading-relaxed font-normal"
    >
      J&apos;accepte les{" "}
      <a
        href={LEGAL_TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-foreground hover:underline"
        onClick={(e) => e.stopPropagation()}
      >
        CGU
      </a>{" "}
      et j&apos;ai pris connaissance de la{" "}
      <a
        href={LEGAL_PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-foreground hover:underline"
        onClick={(e) => e.stopPropagation()}
      >
        politique de confidentialité
      </a>
      .
    </Label>
  </div>
);
